import script from "./AlertsAdminBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertsAdminBoard.vue?vue&type=script&setup=true&lang=js"

import "./AlertsAdminBoard.vue?vue&type=style&index=0&id=7598ef06&lang=scss"

const __exports__ = script;

export default __exports__